/* NOTE: This unified layout is intentional for the new dashboard system.
   It ensures a consistent responsive experience across all auth pages. */
import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import ElevvaLogo from "../Mobile/Elements/ElevvaLogo";
import "./Login/Login.css"; // Reuse shared layout styles

const AuthHeader = memo(() => (
    <div className="mobile-login-header d-flex flex-column align-items-center justify-content-center">
        <div className="mobile-login-logo-container">
            <ElevvaLogo width="100%" height="100%" fill="white" showAccent={true} />
        </div>
    </div>
));

const AuthLayout = () => {
    return (
        <div className="mobile-login-wrapper w-100 flex-grow-1">
            {/* Persistent Dark Splash Header */}
            <AuthHeader />

            {/* Dynamic Content Area (Forms) */}
            <div className="mobile-login-body">
                <div className="auth-internal-scroll">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default memo(AuthLayout);
